export default "__VITE_ASSET__CAInA2lZ__"